import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfPermissionDirective } from './if-permission.directive';

@NgModule({
  declarations: [IfPermissionDirective],
  imports: [CommonModule],
  exports: [IfPermissionDirective]
})
export class IfPermissionModule {}
